import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { ADMIN_USERS } from "../constant";

export const SYSTEM_ADMIN_ROUTES = [
  {
    index: true,
    element: <Navigate to={ADMIN_USERS.SYSTEM} replace />,
  },
  {
    path: ":type",
    lazy: () => import("./admin-list"),
  },
  {
    path: ":type/:userId/*",
    element: <Outlet />,
    children: [
      {
        index: true,
        element: <Navigate to="info" replace />,
      },
      {
        path: "info",
        lazy: () => import("./tabs/view/info-view"),
      },
      {
        path: "edit/info",
        lazy: () => import("./tabs/edit/info-edit"),
      },
    ],
  },
];
